<template>
    <transition name="fade-transform" mode="out-in">
        <div class="filter-wrap" ref="secrchRef" v-show="bSearch">
            <div class="filter-title">
                <div>范围</div>
            </div>
            <div class="select-wrap">
                <div class="select-top-wrap select-left">
                    <div class="select-item" @click="openSelect(0)">
                        <div class="select-title">{{ areaForm[0].title || '大区' }}</div>
                        <img src="~@/assets/images/result/chevron-down.png" alt="">
                    </div>
                    <div class="select-item" @click="openSelect(1)">
                        <div class="select-title">{{ areaForm[1].title || '城市' }}</div>
                        <img src="~@/assets/images/result/chevron-down.png" alt="">
                    </div>
                </div>
                <div class="select-item select-right" @click="openSelect(2)">
                    <div class="select-title">{{ areaForm[2].title || '渠道' }}</div>
                    <img src="~@/assets/images/result/chevron-down.png" alt="">
                </div>
                <div class="select-top-wrap select-left">
                    <div class="select-item" @click="openSelect(3)">
                        <div class="select-title">{{ areaForm[3].title || '门店' }}</div>
                        <img src="~@/assets/images/result/chevron-down.png" alt="">
                    </div>
                    <div class="select-item" @click="openSelect(4)">
                        <div class="select-title">{{ areaForm[4].title || '市区' }}</div>
                        <img src="~@/assets/images/result/chevron-down.png" alt="">
                    </div>
                </div>
                <div class="select-item select-right" @click="openSelect(5)">
                    <div class="select-title">{{ areaForm[5].title || '签单手' }}</div>
                    <img src="~@/assets/images/result/chevron-down.png" alt="">
                </div>
                <div class="select-item select-left" @click="openSelect(6)">
                    <div class="select-title">{{ areaForm[6].title || '代理商' }}</div>
                    <img src="~@/assets/images/result/chevron-down.png" alt="">
                </div>
                <div class="select-item select-right" @click="openSelect(7)">
                    <div class="select-title">{{ areaForm[7].title || '负责人' }}</div>
                    <img src="~@/assets/images/result/chevron-down.png" alt="">
                </div>
            </div>
            <div class="filter-title">
                <div>周期</div>
            </div>
            <div class="cycle-wrap">
                <div v-for="(item, index) in dateList" :key="index" :class="['cycle-item', index === curDate && 'cycle-item-act']" @click="changeSelectDate(index)">{{ item.title }}</div>
            </div>
            <!-- <div class="filter-title">
                <div>用户筛选</div>
            </div>
            <div class="select-wrap">
                <div class="select-top-wrap select-left">
                    <div class="select-item" @click="openSelect(8)">
                        <div class="select-title">{{ areaForm[8].title || '客户状态' }}</div>
                        <img src="~@/assets/images/result/chevron-down.png" alt="">
                    </div>
                    <div class="select-item" @click="openSelect(9)">
                        <div class="select-title">{{ areaForm[9].title || '城市' }}</div>
                        <img src="~@/assets/images/result/chevron-down.png" alt="">
                    </div>
                </div>
                <div class="select-item select-right" @click="openSelect(10)">
                    <div class="select-title">{{ areaForm[10].title || '需求类型' }}</div>
                    <img src="~@/assets/images/result/chevron-down.png" alt="">
                </div>
                <div class="select-item select-left" @click="openSelect(11)">
                    <div class="select-title">{{ areaForm[11].title || '代理商' }}</div>
                    <img src="~@/assets/images/result/chevron-down.png" alt="">
                </div>
                <div class="select-item select-right" @click="openSelect(12)">
                    <div class="select-title">{{ areaForm[12].title || '签单手' }}</div>
                    <img src="~@/assets/images/result/chevron-down.png" alt="">
                </div>
            </div>
            <div class="filter-title">
                <div>合同/项目筛选</div>
            </div>
            <div class="select-wrap">
                <div class="select-top-wrap select-left">
                    <div class="select-item" @click="openSelect(13)">
                        <div class="select-title">{{ areaForm[13].title || '项目类型' }}</div>
                        <img src="~@/assets/images/result/chevron-down.png" alt="">
                    </div>
                    <div class="select-item" @click="openSelect(14)">
                        <div class="select-title">{{ areaForm[14].title || '合同类型' }}</div>
                        <img src="~@/assets/images/result/chevron-down.png" alt="">
                    </div>
                </div>
                <div class="select-item select-right" @click="openSelect(15)">
                    <div class="select-title">{{ areaForm[15].title || '合同审核状态' }}</div>
                    <img src="~@/assets/images/result/chevron-down.png" alt="">
                </div>
                <div class="select-item select-left" @click="openSelect(16)">
                    <div class="select-title">{{ areaForm[16].title || '项目经理' }}</div>
                    <img src="~@/assets/images/result/chevron-down.png" alt="">
                </div>
                <div class="select-item select-right" @click="openSelect(17)">
                    <div class="select-title">{{ areaForm[17].title || '项目阶段' }}</div>
                    <img src="~@/assets/images/result/chevron-down.png" alt="">
                </div>
            </div> -->
            <!-- <div class="select-btn">
                <div>确认</div>
            </div> -->
            <van-popup round position="bottom" v-model="popShow">
                <van-picker :title="selectTitle" value-key="title" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="popShow = false" />
            </van-popup>
        </div>
    </transition>
</template>

<script>
import oJourneyJs from "@/js/hvac/performance/user.js"

export default {
    props: {
        bSearch: {
            type: Boolean,
            default: () => false,
        },
    },
    // 业绩在线 筛选
    name: "index",
    data() {
        return {
            popShow: false,
            selectTitle: "",
            columns: [
                { title: "第一大区", id: 1 },
                { title: "第二作战区", id: 2 },
                { title: "第三战区", id: 3 },
            ],
            areaForm: [],
            curSelect: 0,
            curDate: -1,
            dateList: [
                // "昨天", "7天", "30天", "自定义"
            ],
            //搜索参数
            oSearchForm:{
                sStart:"",
                sEnd:""
            }
        };
    },
    created() {
        this.areaForm = new Array(18);
        this.areaForm.fill({}, 0, 18);
        $init(() => {
            //console.log("created")
            this.getSearchForm()
        })
    },
    methods: {
        // 打开选择器
        openSelect(index) {
            this.curSelect = index;
            switch (index) {
                case 0:
                    this.selectTitle = "选择大区";
                    this.columns = [
                        { title: "第一大区", id: 1 },
                        { title: "第二作战区", id: 2 },
                        { title: "第三战区", id: 3 },
                    ];
                    break;
                case 1:
                    this.selectTitle = "选择城市";
                    this.columns = [
                        { title: "北京" },
                        { title: "上海" },
                        { title: "南昌" },
                    ];
                    break;
                case 2:
                    this.selectTitle = "选择渠道";
                    this.columns = [
                        { title: "渠道一" },
                        { title: "渠道二" },
                        { title: "渠道三" },
                    ];
                    break;
                case 3:
                    this.selectTitle = "选择门店";
                    this.columns = [
                        { title: "门店一" },
                        { title: "门店二" },
                        { title: "门店三" },
                    ];
                    break;
                case 4:
                    this.selectTitle = "选择市区";
                    this.columns = [
                        { title: "北京" },
                        { title: "上海" },
                        { title: "南昌" },
                    ];
                    break;
                case 5:
                    this.selectTitle = "选择签单手";
                    this.columns = [
                        { title: "签单手一" },
                        { title: "签单手二" },
                        { title: "签单手三" },
                    ];
                    break;
                case 6:
                    this.selectTitle = "选择代理商";
                    this.columns = [
                        { title: "代理商一" },
                        { title: "代理商二" },
                        { title: "代理商三" },
                    ];
                    break;
                case 7:
                    this.selectTitle = "选择负责人";
                    this.columns = [
                        { title: "负责人一" },
                        { title: "负责人二" },
                        { title: "负责人三" },
                    ];
                    break;
                case 8:
                    this.selectTitle = "选择客户状态";
                    this.columns = [
                        { title: "客户状态一" },
                        { title: "客户状态二" },
                        { title: "客户状态三" },
                    ];
                    break;
                case 9:
                    this.selectTitle = "选择城市";
                    this.columns = [
                        { title: "北京" },
                        { title: "上海" },
                        { title: "南昌" },
                    ];
                    break;
                case 10:
                    this.selectTitle = "选择需求类型";
                    this.columns = [
                        { title: "需求类型一" },
                        { title: "需求类型二" },
                        { title: "需求类型三" },
                    ];
                    break;
                case 11:
                    this.selectTitle = "选择代理商";
                    this.columns = [
                        { title: "代理商一" },
                        { title: "代理商二" },
                        { title: "代理商三" },
                    ];
                    break;
                case 12:
                    this.selectTitle = "选择签单手";
                    this.columns = [
                        { title: "签单手一" },
                        { title: "签单手二" },
                        { title: "签单手三" },
                    ];
                    break;
                case 13:
                    this.selectTitle = "选择项目类型";
                    this.columns = [
                        { title: "项目类型一" },
                        { title: "项目类型二" },
                        { title: "项目类型三" },
                    ];
                    break;
                case 14:
                    this.selectTitle = "选择合同类型";
                    this.columns = [
                        { title: "合同类型一" },
                        { title: "合同类型二" },
                        { title: "合同类型三" },
                    ];
                    break;
                case 15:
                    this.selectTitle = "选择合同审核状态";
                    this.columns = [
                        { title: "合同审核状态一" },
                        { title: "合同审核状态二" },
                        { title: "合同审核状态三" },
                    ];
                    break;
                case 16:
                    this.selectTitle = "选择项目经理";
                    this.columns = [
                        { title: "项目经理一" },
                        { title: "项目经理二" },
                        { title: "项目经理三" },
                    ];
                    break;
                case 17:
                    this.selectTitle = "选择项目阶段";
                    this.columns = [
                        { title: "项目阶段一" },
                        { title: "项目阶段二" },
                        { title: "项目阶段三" },
                    ];
                    break;
            }
            this.popShow = true;
        },
        onConfirm(e) {
            this.areaForm[this.curSelect] = e;
            this.popShow = false;
            this.$forceUpdate();
        },
        // 切换日期
        changeSelectDate(index) {
            if (index === this.curDate) {
                this.curDate = -1;
                this.oSearchForm.sStart=""
                this.oSearchForm.sEnd=""
            } else {
                this.curDate = index;
                let date =this.dateList[index]
                this.oSearchForm.sStart=date.start
                this.oSearchForm.sEnd=date.end
                // console.log(date)
            }

            this.sendSearchForm()
        },
        //获取搜索数据
        getSearchForm(){
            //console.log("getSearchForm")
            oJourneyJs.getJourneySearch().then(res=>{
                let data=res.data.data.result
                this.dateList=data.period
            })
        },
        //传递搜索表单数据 去刷新数据
        sendSearchForm(){
            this.$emit("searchForm",this.oSearchForm)
        }
    },
};
</script>

<style lang="scss" scoped>
.fade-transform-leave-active,
.fade-transform-enter-active {
    transition: all 0.5s;
}
.fade-transform-enter {
    opacity: 0;
    transform: translateY(-30px);
}
.fade-transform-leave-to {
    opacity: 0;
    transform: translateY(-30px);
}
.filter-wrap {
    width: 100%;
    border-radius: 12px;

    .filter-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
        line-height: 40px;

        img {
            width: 32px;
            height: 32px;
        }
    }

    .select-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 10px 0 28px;
        border-bottom: 2px dashed #f1f1f1;
        margin-bottom: 26px;

        .select-top-wrap {
            display: flex;
            justify-content: space-between;
            align-items: center;

            div {
                width: 46%;

                div {
                    width: 70%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }

        .select-item {
            padding: 0 18px;
            border-radius: 12px;
            border: 2px solid #dbdbdb;
            display: flex;
            align-items: center;
            justify-content: space-between;

            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #858585;
            line-height: 60px;
            margin-top: 10px;
            .select-title {
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                word-break: break-all;
            }

            img {
                width: 32px;
                height: 32px;
            }
        }

        .select-left {
            width: 65%;
        }

        .select-right {
            width: 30%;
        }
    }
    .select-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        div {
            width: 180px;
            border-radius: 12px;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 28px;
            background: $deepGreen;
        }
    }

    .cycle-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;
        margin-bottom: 26px;
        padding: 0 0 28px;
        border-bottom: 2px dashed #f1f1f1;

        .cycle-item {
            width: 21.7%;
            border-radius: 12px;
            border: 2px solid #dbdbdb;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            text-align: center;
            color: #444444;
            line-height: 60px;
        }

        .cycle-item-act {
            border-color: #318544;
            color: #318544;
        }
    }
}
</style>
